<template>
  <div class="h-full">
    <Transition name="fade">
      <Background
        v-if="(video && !mobile) || (video && slug === 'welcome')"
        :src="video"
      />
    </Transition>

    <RouterView />

    <Transition name="fade">
      <Overlay
        v-if="overlay"
        class="z-20"
      />
    </Transition>

    <vue-progress-bar />

    <CookieConsent
      v-if="!loading"
      button-label="Accept cookies"
      message-before="We use cookies to provide website functionality and to analyse traffic. Our"
      link-label="Cookie Notice"
      message-after="provides more information and explains how to amend your cookie settings."
      href="/cookie-notice"
    />

    <IePrompt />

    <Transition name="fade">
      <Loading
        v-if="loading"
        class="z-20"
      />
    </Transition>
  </div>
<!-- Purge css: -->
<!--
fade-enter-active
fade-leave-active
fade-enter
fade-leave-to
long-fade-enter-active
long-fade-leave-active
long-fade-enter
long-fade-leave-to
fade-down-enter-active
fade-down-leave-active
fade-down-enter
fade-down-leave-to
-->
</template>

<script>
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import CookieConsent from '@/components/CookieConsent.vue'
import IePrompt from '@/components/IePrompt.vue'

import { mapState, mapGetters } from 'vuex'
import Background from '@/components/Background.vue'
import Overlay from '@/components/Overlay.vue'
import Loading from '@/components/Loading.vue'

export default {
  name: 'App',

  components: {
    Background,
    Overlay,
    Loading,
    CookieConsent,
    IePrompt
  },

  data: () => ({
    video: undefined
  }),

  computed: {
    ...mapState([
      'touch',
      'browser',
      'mobile',
      'environment',
      'searchResults',
      'noScroll',
      'slug',
      'overlay',
      'loading',
      'header'
    ]),
    ...mapGetters([ 'post', 'posts', 'highlight', 'welcome' ]),

    environment() {
      return process.env.VUE_APP_ENV
    },
    isMobile() {
      return !!(this.$mq === 'sm' || this.$mq === 'md' || this.$mq === 'lg')
    }
  },

  watch: {
    $route() {
      this.updateVideoBackground()
      document.title = this.post ? `${this.htmlDecode(this.post.title)} | Virtual experience | Coventry university` : 'Virtual experience | Coventry university'
    },
    isMobile() {
      this.$store.commit('isMobile', this.isMobile)
    },
    noScroll() {
      const noSrcollLockElement = document.getElementById('no-scroll-lock')
      return this.noScroll ? disableBodyScroll(noSrcollLockElement) : clearAllBodyScrollLocks(noSrcollLockElement)
    }
  },

  created() {
    this.$store.commit('browser', this.$browser.meta.name)
    this.$store.commit('environment', this.environment)
    this.$store.commit('isMobile', this.isMobile)

    this.$Progress.start()

    // this.$router.beforeEach((to, from, next) => {
    //   this.$Progress.start()
    //   next()
    // })
    this.$router.afterEach((to, from) => {
      this.$Progress.finish()
    })
  },

  mounted() {
    window.addEventListener('touchstart', this.isTouch)
    this.mediaComponentId = document.getElementById('media-component')
  },

  methods: {
    isTouch() {
      this.$store.commit('isTouch')
      document.body.setAttribute('id', 'touch')
      window.removeEventListener('touchstart', this.isTouch)
    },
    updateVideoBackground() {
      if (this.slug === 'more-info' || this.$route.path.includes('explore')) {
        this.video = undefined
      } else if (this.slug === 'welcome') {
        this.video = this.welcome.background.video
      } else {
        this.video = this.highlight.background.video
      }
    }
  }
}
</script>
